import {Inject, Injectable} from '@angular/core';
import {Observable, ReplaySubject} from 'rxjs';
import {first, take} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import {DeregistrationPack} from '../interface/deregistration-pack';
import {CountedAndPaginated} from '../interface/response/counted-and-paginated';
import {ListResponse} from '../interface/response/list-response';
import {Krk} from '../interface/krk';
import {FilterService} from './filter.service';
import {DOCUMENT} from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class DeregistrationPackService {
  public readonly deregistrationPackListSubject: ReplaySubject<CountedAndPaginated<DeregistrationPack>>
    = new ReplaySubject<CountedAndPaginated<DeregistrationPack>>(1);
  public readonly deregistrationPackNotCountedListSubject: ReplaySubject<ListResponse<DeregistrationPack>>
    = new ReplaySubject<ListResponse<DeregistrationPack>>(1);

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document,
  ) { }

  sendForm(formData: object, deregistrationPackId: string): Observable<any> {
    if (!deregistrationPackId) {
      return this.httpClient.post(`/rest/crm/deregistrationPack`, formData)
        .pipe(take(1));
    } else {
      return this.httpClient.put(`/rest/crm/deregistrationPack/${deregistrationPackId}`, formData)
        .pipe(take(1));
    }
  }

  get(deregistrationPackId: string): Observable<DeregistrationPack> {
    return this.httpClient.get(`/rest/crm/deregistrationPack/${deregistrationPackId}`)
      .pipe(first()) as Observable<DeregistrationPack>;
  }

  deleteDeregistrationPack(uuid: string): Observable<any> {
    return this.httpClient.delete(`/rest/crm/deregistrationPack/${uuid}`)
      .pipe(first());
  }

  public loadList(page: number, pageSize: number, filters: object): void {
    this.httpClient.get(`/rest/crm/deregistrationPack?page=${page + 1}&pageSize=${pageSize}&` + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<DeregistrationPack>) => {
        this.deregistrationPackListSubject.next(result);
      });
  }

  public loadNotCountedList(
    page: number,
    pageSize: number,
    filters: object,
    observable?: ReplaySubject<ListResponse<DeregistrationPack>>
  ): void {
    this.httpClient
      .get(`/rest/crm/deregistrationPack?disableCount=1&page=${page + 1}&pageSize=${pageSize}&` + this.filterService.parseFilters(filters))
      .pipe(take(1))
      .subscribe((result: ListResponse<DeregistrationPack>) => {
        if (observable) {
          observable.next(result);
        } else {
          this.deregistrationPackNotCountedListSubject.next(result);
        }
      });
  }

  downloadReport(filters: any): void {
    this.document.location.href = `/rest/crm/deregistrationPack/method/report?` + this.filterService.parseFilters(filters);
  }

  addRegistrationToPack(registrationId: string, deregistrationPackId: string): Observable<any> {
    return this.httpClient.post(`/rest/crm/deregistrationPack/method/addRegistration`, {
      registration: registrationId,
      deregistrationPack: deregistrationPackId,
    }).pipe(first());
  }

  removeRegistrationFromPack(registrationId: string, deregistrationPackId: string): Observable<any> {
    return this.httpClient.post(`/rest/crm/deregistrationPack/method/removeRegistration`, {
      registration: registrationId,
      deregistrationPack: deregistrationPackId,
    }).pipe(first());
  }

  confirmDeregistration(packId: string): Observable<any> {
    return this.httpClient.put(`/rest/crm/deregistrationPack/${packId}/confirmDeregistration`, {})
      .pipe(first());
  }
}
